import { useParams } from "react-router-dom";

import EventoFeinsul from "./feinsul/EventoFeinsul";
import EventoNovo from "./raizes/EntreNos";

export default function EventoRouter() {
  const { id } = useParams();

  if (id === "feinsul-2026") {
    return <EventoFeinsul />;
  }
    if (id === "EntreNos") {
    return <EventoNovo />;
  }

  return <div>Evento não encontrado</div>;
}